// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Styles */
.root_sidebar {

  background-color: var(--sidebar-bg-color);
  color: var(--sidebar-color);
  transition: transform 0.3s ease, visibility 0.3s ease;
  flex-shrink: 0; /* Prevent shrinking */
  visibility: visible; /* Ensure it's visible by default */
}

.root_sidebar.closed {
  transform: translateX(0); /* Slide out of view */
  visibility: hidden;
   /* Completely hide the sidebar */
}


.root_sidebar.open {
  transform: translateX(0); /* Fully visible */
  visibility: visible;
}

/* Layout Styles */
.layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.main-content {
  flex: 1 1; /* Take full available space */
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin: 0;
  transition: margin-right 0.3s ease;
  padding: 0;
  overflow-y: scroll;
}

/* Main content scrollbar - Green theme */
.main-content::-webkit-scrollbar {
  width: 8px;
}

.main-content::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.main-content::-webkit-scrollbar-thumb {
  background: hsl(159, 100%, 51%);
  border-radius: 4px;
}

.main-content::-webkit-scrollbar-thumb:hover {
  background: hsl(160, 100%, 51%);
}

/* Sidebar */
.root_sidebar {
  transition: width 0.3s ease;
}

.root_sidebar.open {
  width: 250px; /* Full width for open sidebar */
}

.root_sidebar.closed {
  width: 50px; /* Fixed width for closed sidebar */
}

/* For RTL and LTR directions */
.root_sidebar.ltr {
  left: 0;
  right: auto;
}

.root_sidebar.rtl {
  right: 0;
  left: auto;
}

/* Main Content */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  transition: margin 0.3s ease;
  padding: 0;
}

/* Content without nav (e.g. login, register): add margin so content is not edge-to-edge */
.main-content-login {
  
  box-sizing: border-box;
}


.sidebar-open {
  background-color: #767171 !important;
}



.sidebar-open.ltr .main-content {
  margin-left: 0;
}

.sidebar-closed.ltr .main-content {
  margin-left: 0; /* Nav and content flush with collapsed sidebar */
}

.sidebar-open.rtl .main-content {
  margin-right: 250px; /* Adjust for open sidebar width */
  
}

.sidebar-closed.rtl .main-content {
  margin-right: 50px; /* Adjust for closed sidebar width */
}



/* Add this rule to remove outline on all elements */
* {
    outline: none !important;
}







`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;;EAEE,yCAAyC;EACzC,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc,EAAE,sBAAsB;EACtC,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,wBAAwB,EAAE,sBAAsB;EAChD,kBAAkB;GACjB,gCAAgC;AACnC;;;AAGA;EACE,wBAAwB,EAAE,kBAAkB;EAC5C,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,kCAAkC;EAClC,UAAU;EACV,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,WAAW,EAAE,mCAAmC;AAClD;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,0FAA0F;AAC1F;;EAEE,sBAAsB;AACxB;;;AAGA;EACE,oCAAoC;AACtC;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,iDAAiD;AACnE;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;;AAEzD;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;;;AAIA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B","sourcesContent":["/* Sidebar Styles */\r\n.root_sidebar {\r\n\r\n  background-color: var(--sidebar-bg-color);\r\n  color: var(--sidebar-color);\r\n  transition: transform 0.3s ease, visibility 0.3s ease;\r\n  flex-shrink: 0; /* Prevent shrinking */\r\n  visibility: visible; /* Ensure it's visible by default */\r\n}\r\n\r\n.root_sidebar.closed {\r\n  transform: translateX(0); /* Slide out of view */\r\n  visibility: hidden;\r\n   /* Completely hide the sidebar */\r\n}\r\n\r\n\r\n.root_sidebar.open {\r\n  transform: translateX(0); /* Fully visible */\r\n  visibility: visible;\r\n}\r\n\r\n/* Layout Styles */\r\n.layout {\r\n  display: flex;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.main-content {\r\n  flex: 1; /* Take full available space */\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #ffffff;\r\n  margin: 0;\r\n  transition: margin-right 0.3s ease;\r\n  padding: 0;\r\n  overflow-y: scroll;\r\n}\r\n\r\n/* Main content scrollbar - Green theme */\r\n.main-content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.main-content::-webkit-scrollbar-track {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.main-content::-webkit-scrollbar-thumb {\r\n  background: hsl(159, 100%, 51%);\r\n  border-radius: 4px;\r\n}\r\n\r\n.main-content::-webkit-scrollbar-thumb:hover {\r\n  background: hsl(160, 100%, 51%);\r\n}\r\n\r\n/* Sidebar */\r\n.root_sidebar {\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.root_sidebar.open {\r\n  width: 250px; /* Full width for open sidebar */\r\n}\r\n\r\n.root_sidebar.closed {\r\n  width: 50px; /* Fixed width for closed sidebar */\r\n}\r\n\r\n/* For RTL and LTR directions */\r\n.root_sidebar.ltr {\r\n  left: 0;\r\n  right: auto;\r\n}\r\n\r\n.root_sidebar.rtl {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n/* Main Content */\r\n.main-content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0;\r\n  transition: margin 0.3s ease;\r\n  padding: 0;\r\n}\r\n\r\n/* Content without nav (e.g. login, register): add margin so content is not edge-to-edge */\r\n.main-content-login {\r\n  \r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n.sidebar-open {\r\n  background-color: #767171 !important;\r\n}\r\n\r\n\r\n\r\n.sidebar-open.ltr .main-content {\r\n  margin-left: 0;\r\n}\r\n\r\n.sidebar-closed.ltr .main-content {\r\n  margin-left: 0; /* Nav and content flush with collapsed sidebar */\r\n}\r\n\r\n.sidebar-open.rtl .main-content {\r\n  margin-right: 250px; /* Adjust for open sidebar width */\r\n  \r\n}\r\n\r\n.sidebar-closed.rtl .main-content {\r\n  margin-right: 50px; /* Adjust for closed sidebar width */\r\n}\r\n\r\n\r\n\r\n/* Add this rule to remove outline on all elements */\r\n* {\r\n    outline: none !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
